import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from 'rebass'

import Title from './Title'

const Section = ({ children, title, bg }) => (
  <Box id={title.toLowerCase()} is="section" bg={bg || `#fff`} py={[3, 4, 5]}>
    <Container>
      <Title title={title.toUpperCase()} />
      <Box my={[2, 3, 4]}> {children}</Box>
    </Container>
  </Box>
)

Section.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  bg: PropTypes.string,
}

export default Section



// WEBPACK FOOTER //
// ./src/containers/Section/Section.js